import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ContactJourneyCreators } from 'app/reducers/ContactJourneyRedux'

import store from 'services/store'

import { Trovit } from 'components/Pixels'

import ContactFormRedux from './index'
import SuccessMessage from './SuccessMessage'

const TROVIT_UTM_SOURCE_TAG = 'lifull-connect' 

class ConnectedForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      success: false
    }
  }

  static propTypes = {
    brokerData: PropTypes.object.isRequired,
    espModeuleRgpd: PropTypes.object,
    currentOcupationStatus: PropTypes.object,
    handleRequestPropertyInfo: PropTypes.func,
  }

  static defaultProps = {
    handleRequestPropertyInfo: () => {},
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.props.sendContactRequest.loading &&
      !nextProps.sendContactRequest.loading &&
      !nextProps.sendContactRequest.error
    ) {
      this.setState({
        success: true
      })
    }
  }

  getTracker = () => {
    const params = (new URL(document.location)).searchParams
    const utm_source = params.get('utm_source')
    const utm_medium = params.get('utm_medium')

    if (utm_source && utm_medium && utm_source.toLocaleLowerCase() === TROVIT_UTM_SOURCE_TAG) {
      return "trovit"
    }
  }

  sendForm = values => {
    const { fullName, telephone, email, message } = values
    const { propertyUrl, propertyId } = this.props
    const utmSource = this.getTracker()
    this.props.actions.sendContact(
      this.props.propertyId,
      fullName,
      telephone,
      email,
      message,
      propertyUrl,
      utmSource
    )

    this.props.actions.sendGTEvent('vip-public', 'send-contact', {
      propertyId
    })

    this.props.handleRequestPropertyInfo()
  }

  render() {
    const { success } = this.state
    const { currentOcupationStatus, errorMessageForm } = this.props

    if (success) {
      return (
        <Fragment>
          <Trovit.Event />
          <SuccessMessage />
        </Fragment>
      )
    }

    return (
      <ContactFormRedux
        initialValues={{
          message: currentOcupationStatus
            ? `Me interesa una propiedad similar a esta que ya fue ${currentOcupationStatus.label}`
            : ''
        }}
        onSubmit={this.sendForm}
        brokerData={this.props.brokerData}
        currentOcupationStatus={currentOcupationStatus}
        handleRequestPhone={this.props.handleRequestPhone}
        errorMessageForm={errorMessageForm}
      />
    )
  }
}

const mapStateToProps = state => ({
  sendContactRequest: store.vipContact('property').selector(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      sendContact: store.vipContact('property').action,
      sendGTEvent: ContactJourneyCreators.sendGTEvent
    },
    dispatch
  )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedForm)
